import { Button, Paper, Title, Table, Box, Grid, Text, Flex } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import B2BButton from '../components/common/B2BButton';
import { createB2BAPI } from '../api/Interceptor';
import { IconArrowLeft } from '@tabler/icons-react';
import { over } from 'lodash';
import DeliveryScheduleModal from './DeliveryScheduleModal';
import { useNavigate } from 'react-router-dom';
import DeliveryScheduleForm from './DeliveryScheduleForm';
import "./SalesOrderTable.css"

const SalesOrderTable = ({
  opened,
  selectedStatusType,
  columns,
  canSave,
  data,
  orderType,
  Stockdata2,
  activeTabTop,
  purchaseOrder,
  handleSaveProduct,
  setPurchaseOrder,
  salesData,
  salesOrder,
  agentData,
  variantId,
  open,
  fromSales,
  isSalesOrder,
  title,
  buttonArr = [],
  fixedcolumns }) => {
  const B2B_API = createB2BAPI();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [modelOpended, setModelOpended] = useState(false);
  const [modelOpended1, setModelOpended1] = useState(false);
  const processedColumns = columns?.map((col) => ({
    ...col,
    accessorFn: col.accessorFn || (col.accessorKey === 'sno'
      ? (_, index) => index + 1
      : undefined),
    Cell: col.formatDate
      ? ({ row }) => dayjs(row.original[col.accessorKey]).format('DD/MM/YYYY')
      : col.Cell,
  }));

  return (
    <div>
      <Paper withBorder p="md">
        <div style={{ display: "flex", justifyContent: 'space-between', backgroundColor: 'lightgray', textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <h3 style={{ padding: '0.5rem' }}>{title}</h3>
            {salesOrder?.customer?.gstnNo || salesData?.customer?.gstnNo && <div style={{ marginRight: '1rem' }}> GST NO : <span > {salesOrder?.customer?.gstnNo || salesData?.customer?.gstnNo}</span></div>}
          </div>
          <div style={{ display: 'flex', gap: '2rem', flexDirection: 'row-reverse', margin: '0.5rem' }}>
            {buttonArr?.map((button, idx) => (
              <B2BButton
                key={idx}
                name={button?.name}
                color={button?.color}
                variant={button?.variant}
                style={button?.style}
                onClick={button?.onClick}
                disabled={button?.disabled}
              />
            ))}
            {!opened && activeTabTop === 'ASN' && selectedStatusType === 'NEW' && <div>
              <Button
                onClick={() => handleSaveProduct(purchaseOrder)}
                style={{ backgroundColor: !canSave ? 'gray' : '#17a6b0ff', color: 'white' }}
                disabled={data?.length === 0 || !canSave}
              >
                Save
              </Button>
            </div>}
          </div>
          {(salesOrder?.orderStatus === 'NEW' || salesOrder?.orderStatus === 'CONFIRMED') &&
            <div style={{ display: 'flex', gap: '2rem', flexDirection: 'row-reverse', marginTop: '0.2rem' }}>
              {((salesOrder?.orderType !== 'SWATCH') && !fromSales) && <B2BButton style={{ background: 'green', marginLeft: '0.5rem' }} disabled={!variantId} onClick={open} name={'Allocate Stock'} />}
            </div>
          }
        </div>
        <Box mt="md">
          {isMobile ? (
            <Flex direction="column" gap="md">
              {data && data.length > 0 ? (
                data.map((row, idx) => (
                  <Paper key={idx} withBorder radius="md" p="md" shadow="xs">
                    <Grid gutter="sm">
                      {processedColumns?.map((col) => {
                        const CellRenderer = col.Cell || col.cell;
                        const cellValue =
                          typeof CellRenderer === 'function'
                            ? CellRenderer({ row: { original: row } })
                            : row[col?.accessorKey];

                        const label = col.mobileLabel || (typeof col.header === 'string' ? col.header : col.accessorKey);
                        const isLongField = col.accessorKey === 'productName' || col.accessorKey === 'productVariant';

                        return (
                          <Grid.Col span={isLongField ? 12 : 6} key={col?.accessorKey}>
                            <Text size="xs" c="dimmed" fw={700} tt="uppercase" mb={4}>
                              {label}
                            </Text>
                            <Box style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                              {cellValue}
                            </Box>
                          </Grid.Col>
                        );
                      })}
                    </Grid>
                  </Paper>
                ))
              ) : (
                <Text ta="center" p="xl" c="dimmed">No data available</Text>
              )}
            </Flex>
          ) : (
            <Box style={{ overflowX: 'auto', width: '100%' }}>
              <Table striped highlightOnHover withColumnBorders withTableBorder style={{ minWidth: '1000px' }}>
                <Table.Thead>
                  <Table.Tr>
                    {processedColumns?.map((col) => (
                      <Table.Th key={col.accessorKey} style={{ backgroundColor: '#f1f3f5' }}>
                        {col.header}
                      </Table.Th>
                    ))}
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {data && data.length > 0 ? (
                    data.map((row, idx) => (
                      <Table.Tr key={idx}>
                        {processedColumns?.map((col) => {
                          const CellRenderer = col.Cell || col.cell;
                          const cellValue =
                            typeof CellRenderer === 'function'
                              ? CellRenderer({ row: { original: row } })
                              : row[col?.accessorKey];

                          return (
                            <Table.Td key={col?.accessorKey} style={{ textAlign: 'center' }}>
                              {cellValue}
                            </Table.Td>
                          );
                        })}
                      </Table.Tr>
                    ))
                  ) : (
                    <Table.Tr>
                      <Table.Td colSpan={processedColumns.length} style={{ textAlign: "center", padding: "2rem" }}>
                        <Text c="dimmed">No data available</Text>
                      </Table.Td>
                    </Table.Tr>
                  )}
                </Table.Tbody>
              </Table>
            </Box>
          )}
        </Box>

      </Paper >

    </div>
  );
};

export default SalesOrderTable;
